import React, { useEffect, useState } from 'react';

import { useCarousel } from 'src/component/ds/ui/carousel';
import { useTranslation } from 'src/i18n';

export default function CarouselPager () {
  const { t } = useTranslation();
  const { api: emblaApi } = useCarousel();
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (!emblaApi) return undefined;

    const sync = () => {
      setPage(emblaApi.selectedScrollSnap());
      setTotal(emblaApi.scrollSnapList().length);
    };
    sync();
    emblaApi.on('select', sync);
    emblaApi.on('reInit', sync);

    return () => {
      emblaApi.off('select', sync);
      emblaApi.off('reInit', sync);
    };
  }, [emblaApi]);

  if (total < 2) return null;

  return (
    <span
      className='ds-text-ds-mini ds-text-muted-foreground'
      aria-live='polite'
      data-testid='alarm-volume-pager'
    >
      {t('dashboard.alarmVolumePage', { page: page + 1, total })}
    </span>
  );
}
